// Dev route playground
export const DEV_ROUTE = {
  path: '/_dev',
  name: 'dev',
  component: () => import('@/dev/DevView.vue'),
  beforeEnter: () => {
    // Check if we are in dev mode to let the access
    if (process.env.NODE_ENV !== 'development') {
      return { name: 'home' };
    }
  }
};
